import { render, staticRenderFns } from "./dropOffTimeoutDetail.vue?vue&type=template&id=45a536d0&scoped=true"
import script from "./dropOffTimeoutDetail.vue?vue&type=script&lang=js"
export * from "./dropOffTimeoutDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a536d0",
  null
  
)

export default component.exports